import { render } from "./ModalTermsCondition.vue?vue&type=template&id=50a8cafb&scoped=true"
import script from "./ModalTermsCondition.vue?vue&type=script&lang=js"
export * from "./ModalTermsCondition.vue?vue&type=script&lang=js"

import "./ModalTermsCondition.vue?vue&type=style&index=0&id=50a8cafb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50a8cafb"]])

export default __exports__